var Api = /** @class */ (function () {
    function Api() {
    }
    Api.Markets = {
        RemoveMarket: "market/remove",
        GetMarkets: "market/get",
        GetMarketsById: "market/getMarkets",
        Publish: "market/publish",
        Save: "market/save",
        SaveAll: "market/saveAll",
        Settle: "market/settle",
        Suspend: "market/suspend",
        Resume: "market/resume",
        GenerateMarket: "market/Generate",
        PlaceBet: "market/PlaceBet"
    };
    Api.Matches = {
        GetMatches: "match",
        CreateMatch: "match/Create",
    };
    Api.JsonLocks = {
        RemoveUserJsonLocks: "JsonLock/RemoveUserJsonLocks",
    };
    Api.ApiSettings = {
        GetApiSetting: "ApiSettings/getApiSetting",
        SaveApiSetting: "ApiSettings/saveApiSettings",
        DeleteApiSetting: "ApiSettings/delete"
    };
    Api.Events = {
        GetEvent: "event",
        SuspendAll: "event/suspendAll",
        GetFeaturedEvents: "event/getFeaturedEvents",
        GetMyFeaturedEvents: "event/getMyFeaturedEvents",
        CreateEvent: "event/CreateEvent",
        DeleteEvents: "event/DeleteEvents",
        SetAutoPick: "event/SetAutoPick",
        UpdateEvent: "event/UpdateEvent",
        AutoPickMySelections: "event/AutoPickMySelections"
    };
    Api.Jackpot = {
        Join: "jackpot/join",
        GetJackpot: "jackpot/GetJackpot",
        GetJackpotWinningOddsForEvent: "jackpot/GetJackpotWinningOddsForEvent",
        GetBrandJackpotLeaderBoard: "jackpot/GetBrandJackpotLeaderBoard",
        GetEventJackpotLeaderBoard: "jackpot/GetEventJackpotLeaderBoard",
        IsUserJoinedJackpot: "jackpot/IsUserJoinedJackpot",
        GetRules: "jackpot/GetRules",
        SaveRules: "jackpot/SaveRules",
    };
    Api.RunningBall = {
        GetAllLeagues: "runningball/allLeagues",
        GetLeagues: "runningball/leagues",
        GetAllLeagueMatches: "runningball/allLeagueMatches",
        GetLeagueEvents: "runningball/leagueEvents",
        SaveSubscriptions: "runningball/saveSubscriptions",
        GetFlag: "runningball/flag"
    };
    Api.Leagues = {
        GetLeauge: "league/getLeague",
        GetLeauges: "league/getLeagues",
        GetMyLeauges: "league/getMyLeagues",
    };
    Api.Attachments = {
        Save: "attachment"
    };
    Api.Billings = {
        GetBillingTotals: "billing/getBillingTotals",
        GetBillingTotalsThisPeriod: "billing/getBillingTotalsThisPeriod"
    };
    Api.AffiliateLinkAnalytic = {
        Record: "AffiliateLinkAnalytic/Record",
    };
    Api.ManageBrands = {
        Get: "brand",
        GetTemplates: "brand/getTemplates",
        GetLotteryWidgets: "brand/GetLotteryWidgets",
        getStats: "brand/getStats",
        GetBrandCurrencies: "brand/getBrandCurrencies",
        GetCustomBrands: "brand/getCustomBrands",
        CheckUsingCustomBrands: "brand/checkUsingCustomBrands",
        GetBrandings: "brand/getbranding",
        Delete: "brand/delete",
        DeleteBrandTheme: "brand/deleteBrandTheme",
        Save: "brand/save",
        SaveTemplates: "brand/saveTemplates",
        SaveLotteryWidgets: "brand/SaveLotteryWidgets",
        SaveBranding: "brand/savebranding",
        ManageOperatorLotteriesForPricing: "brand/manageOperatorLotteriesForPricing",
        SaveSubscriptions: "brand/saveSubscriptions",
        GetLotteryBrandSubsciptions: "brand/getLotteryBrandSubsciptions",
        ManageBrandLotterySubscriptions: "brand/manageBrandLotterySubscriptions",
        GetInstantGameBrandSubsciptions: "brand/getInstantGameBrandSubsciptions",
        Topup: "brand/topup",
        ManageBrandInstantGameSubscriptions: "brand/manageBrandInstantGameSubscriptions",
        AreMarginValuesValid: "brand/AreMarginValuesValid",
        ValidateBrandLotteriesMarginCost: "brand/validateBrandLotteriesMarginCost",
        GetSweepstakeBrandSubsciptions: "brand/getBrandSweepstakeSubscriptions",
        ManageBrandSweepstakeSubscriptions: "brand/manageBrandSweepstakeSubscriptions",
    };
    Api.ManageOperators = {
        Get: "operator",
        Save: "operator/save",
        Delete: "operator/delete",
        Topup: "operator/topup",
        GetInsurancePolicies: "operator/getInsurancePolicies",
    };
    Api.Analytics = {
        Get: "analytics",
    };
    Api.Client = {
        GetHotLotteriesById: "Client/GetHotLotteriesById",
        GetLobbyBundles: "Client/GetLobbyBundles",
        GetBrandLotterySyndicates: "Client/GetBrandLotterySyndicates",
        GetLobbyBrandLotteries: "Client/GetLobbyBrandLotteries",
        GetLobbyBrandInstantGames: "Client/GetLobbyBrandInstantGames",
        GetLobbyBrandScratchcards: "Client/GetLobbyBrandScratchcards",
        GetLotteryAdditionalInfo: "Client/GetLotteryAdditionalInfo",
        GetLobbyLatestResults: "Client/GetLobbyLatestResults",
        GetClientLottery: "Client/lottery",
        GetClientInstantGame: "Client/instantGame",
        GetInstantGameUserPlayInfo: "Client/getInstantGameUserPlayInfo",
        MarkTransactionAsComplete: "Client/markTransactionAsComplete",
        GetClientBundle: "Client/bundle",
        GetClientSyndicate: "Client/syndicate",
        GetResultsBrandLotteries: "Client/GetResultsBrandLotteries",
        GetResultsLatestResults: "Client/GetResultsLatestResults",
        GetMyPurchases: "Client/GetMyPurchases",
        GetAgentWinningClaims: "Client/GetAgentWinningClaims",
        GetNextDraw: "Client/GetNextDraw",
        ChangeWinningClaimPayoutStatus: "Client/ChangeWinningClaimPayoutStatus",
        SetPurchasesAsNotified: "Client/SetPurchasesAsNotified",
        GetPurchasesNotificationCount: "Client/GetPurchasesNotificationCount",
        GetCart: "Client/GetCart",
        GetCartCount: "Client/GetCartCount",
        GetSavedTickets: "Client/GetSavedTickets",
        GetBundleSavedTickets: "Client/GetBundleSavedTickets",
        DeleteTicket: "Client/DeleteTicket",
        RemoveCartItem: "Client/RemoveCartItem",
        CreateOrModifyTicket: "Client/CreateOrModifyTicket",
        CreateOrModifyTicketBulk: "Client/CreateOrModifyTicketBulk",
        PurchaseTickets: "Client/PurchaseTickets",
        PurchaseInstantGameTickets: "Client/PurchaseInstantGameTickets",
        AddTicketsToCart: "Client/AddTicketsToCart"
    };
    Api.ManageWinningNominationClaims = {
        Get: "winningNominationClaim",
        GetInstantGame: "winningNominationClaim/instantGame",
        GetSweepstake: "winningNominationClaim/sweepstake",
        Save: "winningNominationClaim/save"
    };
    Api.ManageLotteries = {
        GetLotteryDrawsForPeriod: "lottery/GetLotteryDrawsForPeriod",
        GetDrawsForLottery: "lottery/GetDrawsForLottery",
        GetDrawsForMultipleLottery: "lottery/GetDrawsForMultipleLotteries",
        GetLotteriesByBrand: "lottery/GetLotteriesByBrand",
        GetBundlesByBrand: "lottery/GetBundlesByBrand",
        GetAll: "lottery/all",
        GetForAdmin: "lottery/getFromAdmin",
        GetFeed: "lotteryfeed",
        Save: "lottery/save",
        Delete: "lottery/delete",
        GetLotteriesInsuranceInfo: "lottery/getLotteriesInsuranceInfo",
        CalculatePrice: "lottery/calculatePrice"
    };
    Api.ManageInstantGames = {
        GetForAdmin: "instantGame/getFromAdmin",
        Save: "instantGame/save",
        Delete: "instantGame/delete",
        GetAll: "instantGame/getAll",
        GetInstantGamesByBrand: "instantGame/getInstantGamesByBrand",
    };
    Api.ManageBundles = {
        GetForAdmin: "bundle/getFromAdmin",
        Save: "bundle/save",
        Delete: "bundle/delete",
    };
    Api.ManageSyndicates = {
        GetForAdmin: "syndicate/getFromAdmin",
        Save: "syndicate/save",
        Delete: "syndicate/delete",
    };
    Api.Currencies = {
        GetCurrencies: "currency/currencies",
        GetRates: "currency/rates",
    };
    Api.TicketLines = {
        GetTicketLines: "ticketLine"
    };
    Api.TicketDraws = {
        GetTicketDraw: "ticketDraw"
    };
    Api.ManagePlayers = {
        Get: "player",
        Save: "player/save",
        GetStat: "player/getStats"
    };
    Api.Transactions = {
        Get: "transaction"
    };
    Api.EventTemplate = {
        GetEventTemplate: "EventTemplate",
        SaveEventTemplate: "EventTemplate/save"
    };
    Api.Tag = {
        Get: "Tag"
    };
    Api.ManageSweepstakes = {
        GetForAdmin: "sweepstake/getFromAdmin",
        Save: "sweepstake/save",
        Delete: "sweepstake/delete",
        GetAll: "sweepstake/getAll",
        GetSweepstakesByBrand: "sweepstake/getByBrand",
        CreateNewDraw: "sweepstake/createNewDraw"
    };
    return Api;
}());
export { Api };
